var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16665 17.2611V4.09448C9.16665 2.84448 8.63331 2.34448 7.30831 2.34448H3.94165C2.61665 2.34448 2.08331 2.84448 2.08331 4.09448V17.2611C2.08331 18.5112 2.61665 19.0112 3.94165 19.0112H7.30831C8.63331 19.0112 9.16665 18.5112 9.16665 17.2611Z",
    fill: "#B90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9166 17.0446V13.4779C17.9166 12.3946 17.0833 11.5112 16.0583 11.5112H12.6916C11.6666 11.5112 10.8333 12.3946 10.8333 13.4779V17.0446C10.8333 18.1279 11.6666 19.0112 12.6916 19.0112H16.0583C17.0833 19.0112 17.9166 18.1279 17.9166 17.0446Z",
    fill: "#B90022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9166 7.87782V4.31115C17.9166 3.22782 17.0833 2.34448 16.0583 2.34448H12.6916C11.6666 2.34448 10.8333 3.22782 10.8333 4.31115V7.87782C10.8333 8.96115 11.6666 9.84448 12.6916 9.84448H16.0583C17.0833 9.84448 17.9166 8.96115 17.9166 7.87782Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardactive);
export default __webpack_public_path__ + "static/media/dashboardactive.c7900379ea1705af98a2e0c6c7ba5901.svg";
export { ForwardRef as ReactComponent };